import { MapperInterface } from "@app/shared/mapper/mapper-inteface";
import { Injectable } from "@angular/core";
import { MapperSettore } from "./mapper-settore";
import { MapperProcedimento } from "./mapper-procedimento";
import { MapperCampoSpecificoFascicolo } from "./mapper-campo-specifico-fascicolo";
import { MapperTempiConservazione } from "./mapper-tempi-conservazione";
import { FiltroRicercaAttoDTO } from "../dto/filtro-ricerca-attoDTO";
import { FiltroRicercaAttoVO } from "../vo/filtro-ricerca-attoVO";
import { StatoAttoEnum } from "../enum/stato-atto-enum";
import { MapperUtente } from "./mapper-utente";

@Injectable({
  providedIn: "root",
})
export class MapperFiltroRicercaAtto
  implements
  MapperInterface<FiltroRicercaAttoDTO, FiltroRicercaAttoVO> {
  constructor(
    private mapperSettore: MapperSettore,
    private mapperProcedimenti: MapperProcedimento,
    private mapperCampoSpecifico: MapperCampoSpecificoFascicolo,
    private mapperTempiConservazione: MapperTempiConservazione,
    private mapperUtente: MapperUtente
  ) { }

  convertVoToDto(vo: FiltroRicercaAttoVO): FiltroRicercaAttoDTO {
    if (vo != null) {
      const dto = new FiltroRicercaAttoDTO();

      dto.annoAtto = vo.annoAtto;
      dto.redattore = this.mapperUtente.convertVoToDto(vo.redattore);
      dto.responsabile = this.mapperUtente.convertVoToDto(vo.responsabile);
      dto.settore = this.mapperSettore.convertVoToDto(vo.settore);
      dto.sedutaPrenotata = vo.sedutaPrenotata;
      dto.dataInserimentoAl = vo.dataInserimentoAl;
      dto.dataInserimentoDal = vo.dataInserimentoDal;
      dto.oggetto = vo.oggetto;
      dto.ricercaSemplice = vo.ricercaSemplice;
      dto.segnaturaArchivistica = vo.segnaturaArchivistica;
      dto.procedimentiAmministrativiAssociati = this.mapperProcedimenti.convertListVoToDto(
        vo.procedimentiAmministrativiAssociati
      );
      dto.campiSpecifici = this.mapperCampoSpecifico.convertListVoToDto(
        vo.campiSpecifici
      );
      dto.numeroRepertorio = vo.numeroRepertorio;
      dto.dataRepertoriazioneDal = vo.dataRepertoriazioneDal;
      dto.dataRepertoriazioneAl = vo.dataRepertoriazioneAl;
      dto.tempiConservazione = this.mapperTempiConservazione.convertVoToDto(
        vo.tempiConservazione
      );
      if (vo.tipologiaDecreto !== "" && vo.tipologiaDecreto != null) {
        dto.tipologiaDecreto = vo.tipologiaDecreto;
      }
      dto.textSearch = vo.textSearch;
      dto.limitazioniVisibilita = vo.limitazioniVisibilita;
      dto.pageNumber = vo.pageNumber;
      dto.sort = vo.sort;
      dto.direz = vo.direz;
      dto.stato = <StatoAttoEnum[]>((vo.stato === null || vo.stato === undefined || Array.isArray(vo.stato)) ? vo.stato : [vo.stato]);
      switch (vo.statoDaEscludere) {
        case "BOZZA":
          dto.statoDaEscludere = StatoAttoEnum.BOZZA;
          break;
      }
      return dto;
    } else {
      return null;
    }
  }

  convertDtoToVo(dto: FiltroRicercaAttoDTO): FiltroRicercaAttoVO {
    if (dto != null) {
      const vo = new FiltroRicercaAttoVO();
      // TODO fare mapper questa riga funge solo se DTO e VO sono identici
      // vo = JSON.parse(JSON.stringify(dto));

      return vo;
    } else {
      return null;
    }
  }

  convertListVoToDto(
    voList: FiltroRicercaAttoVO[]
  ): FiltroRicercaAttoDTO[] {
    if (voList != null) {
      return voList.map((vo) => this.convertVoToDto(vo));
    } else {
      return null;
    }
  }

  convertListDtoToVo(
    dtoList: FiltroRicercaAttoDTO[]
  ): FiltroRicercaAttoVO[] {
    if (dtoList != null) {
      return dtoList.map((dto) => this.convertDtoToVo(dto));
    } else {
      return null;
    }
  }
}
